export const isOfType = (type: string, val: any):
 boolean => (val.constructor
    && val.constructor.name.toLowerCase() === type.toLowerCase()
);
